import Vue from "vue";

Vue.directive("focus", {
  inserted: function (el) {
    // 聚焦元素
    el.querySelector("input").focus();
  },
});